"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icon_animation_enum_1 = __importDefault(require("../../shared/enums/icon-animation.enum"));
var icon_size_enum_1 = __importDefault(require("../../shared/enums/icon-size.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var icon_1 = __importDefault(require("../icon"));
function AnimatedIcon(props) {
    var size = icon_size_enum_1.default[props.icon.size || icon_size_enum_1.default.X1];
    var style = { width: size, height: size };
    var animationType = (props === null || props === void 0 ? void 0 : props.animationType) || icon_animation_enum_1.default.PULSE;
    var shower = animationType === icon_animation_enum_1.default.SHOWER;
    var count = shower ? 9 : 2;
    // NOTE: style doesn't appear to be rendered as an attribute. This may be a bug.
    return (react_1.default.createElement("div", { className: (0, classMap_1.default)("mpng-ux-animated-icon position-absolute", props.className), style: style }, Array(props.enabled ? count : 1)
        .fill(null)
        .map(function (value, index) {
        var _a;
        return (react_1.default.createElement("div", { className: (0, classMap_1.default)("position-absolute animation", index !== 0 ? animationType : "z-index-2"), key: index, style: style },
            react_1.default.createElement(icon_1.default, __assign({}, props.icon, { className: (0, classMap_1.default)("position-absolute", (_a = props.icon) === null || _a === void 0 ? void 0 : _a.className), alt: props.alt || "" }))));
    })));
}
exports.default = AnimatedIcon;
